import React from "react";

const Footer = () => {
  return (
    <section className='footer-section'>
      <div class='footer-center'>
        <p>
          <a href='https://franekdev-portfolio.netlify.app/contact.html'>
            &copy; FranekDev
          </a>
          <i> &nbsp;all rights reserved</i>
        </p>
      </div>
    </section>
  );
};

export default Footer;
